import { DocumentNode, gql } from '@apollo/client';
import * as React from 'react';

import { ConferenceEventSponsor_OrganizationFragment } from './graphql-types/ConferenceEventSponsor_OrganizationFragment';

export const ConferenceEventSponsor: React.FC<{
  sponsors: ConferenceEventSponsor_OrganizationFragment[];
  isHtml: boolean;
  eventSponsorshipTiersName: string;
}> & {
  sponsorFragment: DocumentNode;
} = (props) => {
  return (
    <>
      {props.isHtml ? (
        <h3>{props.eventSponsorshipTiersName}</h3>
      ) : (
        <>
          {props.eventSponsorshipTiersName}: <br />
        </>
      )}

      {props.sponsors.map((sponsor) =>
        props.isHtml ? (
          <b key={sponsor._id}>{sponsor.displayName}</b>
        ) : (
          <React.Fragment key={sponsor._id}>
            - {sponsor.displayName}
            <br />
          </React.Fragment>
        )
      )}
    </>
  );
};

ConferenceEventSponsor.sponsorFragment = gql`
  fragment ConferenceEventSponsor_OrganizationFragment on Organization {
    _id
    displayName
  }
`;
